<template>
  <v-expansion-panel :title="t('user-table')">
    <v-expansion-panel-text v-if="selectedOrgId">
      <v-form @submit.prevent="getPeople" validate-on="submit">
        <div class="search-container">
          <v-text-field
            v-model="searchName"
            :placeholder="t('name')"
            clearable
            hide-details
            variant="outlined"
          />
          <v-text-field
            v-model="searchEmail"
            :placeholder="t('email')"
            clearable
            hide-details
            variant="outlined"
          />
        </div>
        <v-btn type="submit" class="search-btn" color="primary">{{ t("search") }}</v-btn>
      </v-form>

      <div v-if="loading" class="grid-loading">
        <v-progress-circular indeterminate />
      </div>
      <v-table v-else>
        <thead>
          <tr>
            <th class="text-left">{{ t("name") }}</th>
            <th class="text-left">{{ t("email") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="person in people"
            :key="person.PK"
            class="person"
            @click="emitClick(person)"
          >
            <td>{{ person?.displayData?.name }}</td>
            <td>{{ person?.displayData?.email }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-expansion-panel-text>
    <v-expansion-panel-text v-else>
      <div>{{ t("select-an-org") }}</div>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>
<script setup>
import { ref, watch, toRefs } from "vue";
import { appSyncApolloClient } from "../../helpers/api";
import gql from 'graphql-tag';
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  selectedOrgId: {
    type: String
  }
});
const { selectedOrgId } = toRefs(props);

const searchEmail = ref();
const searchName = ref();

const people = ref([]);
const loading = ref(false);

async function getPeople() {
  if (!selectedOrgId.value) return;
  loading.value = true;
  const filters = [
    {
      attribute: "SK",
      condition: "equals",
      key: true,
      value: selectedOrgId.value,
    },
  ];
  if (searchName.value) {
    filters.push({
      attribute: "displayData.name",
      condition: "contains",
      value: searchName.value,
    });
  }
  if (searchEmail.value) {
    filters.push({
      attribute: "displayData.email",
      condition: "contains",
      value: searchEmail.value,
    });
  }
  const resp = await appSyncApolloClient.query({
    query: gql`
      query filterOrgsData($input: ServerFilters) {
        filterOrgsData(input: $input) {
          items {
            PK
            displayData {
              name
              email
              firstName
              lastName
            }
          }
          LastEvaluatedKey
        }
      }
    `,
    variables: {
      input: {
        Limit: 10,
        IndexName: "GSI1",
        LastEvaluatedKey: null,
        filters,
      },
    },
  });
  people.value = resp?.data?.filterOrgsData?.items;
  loading.value = false;
}

watch(selectedOrgId, getPeople)

const emit = defineEmits(["clickPerson"]);
function emitClick(person) {
  emit("clickPerson", person);
}
</script>
<i18n>
{
  "en": {
    "user-table": "User Table",
    "name": "Name",
    "email": "Email",
    "search": "Search",
    "select-an-org": "Select an org"
  },
  "es": {
    "user-table": "Tabla de Usuarios",
    "name": "Nombre",
    "email": "Correo Electrónico",
    "search": "Buscar...",
    "select-an-org": "Selecciona una Organización"
  }
}
</i18n>
<style scoped>
.grid-loading {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.person:hover {
  color: black;
  background: #eee;
  cursor: pointer;
}

.search-container {
  margin: 10px;
  display: flex;
  gap: 10px;
  div {
    max-width: 200px;
  }
}

.search-btn {
  width: 100%;
  margin: 10px;
}
</style>
